import { numFont } from '../../../utils/fonts';
import React from 'react';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

import { useWidgetFrame } from '../frameContext';

/** Customer feedback (design "Feedback"): rating + star at S, plus a 5-bar distribution at M. */
export default function FeedbackBody({ rating, sub, callbacks, distribution }) {
  const frame = useWidgetFrame();
  const wide = frame?.size === 'M';
  const max = Math.max(1, ...(distribution || [0]));
  return (
    <Box sx={{ flex: 1, minHeight: 0, p: 2, display: 'flex', gap: 2, alignItems: 'stretch' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography sx={{ fontSize: 34, fontWeight: 700, letterSpacing: '-0.5px', lineHeight: 1 }}>{rating}</Typography>
          <StarIcon sx={{ color: '#f6ad55', fontSize: 28 }} />
        </Box>
        <Typography noWrap sx={{ fontSize: 12.5, color: 'text.secondary', mt: 0.5 }}>
          {sub}
        </Typography>
        {callbacks?.n > 0 ? (
          <Typography
            component="button"
            type="button"
            onClick={callbacks.onClick}
            sx={{ mt: 0.75, alignSelf: 'flex-start', background: 'none', border: 0, p: 0, cursor: 'pointer', fontSize: 12.5, fontWeight: 600, color: '#c53030', fontFamily: 'inherit' }}
          >
            {callbacks.label}
          </Typography>
        ) : null}
      </Box>
      {wide && distribution ? (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 0.5 }}>
          {[5, 4, 3, 2, 1].map((stars) => {
            const n = distribution[stars - 1] || 0;
            return (
              <Box key={stars} sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 11.5, color: 'text.secondary' }}>
                <Box sx={{ width: 10, textAlign: 'right' }}>{stars}</Box>
                <Box sx={{ flex: 1, height: 8, borderRadius: 4, bgcolor: '#edf2f7', overflow: 'hidden' }}>
                  <Box sx={{ width: `${(n / max) * 100}%`, height: '100%', bgcolor: stars >= 4 ? '#48bb78' : stars === 3 ? '#f6ad55' : '#fc8181' }} />
                </Box>
                <Box sx={{ width: 22, ...numFont }}>{n}</Box>
              </Box>
            );
          })}
        </Box>
      ) : null}
    </Box>
  );
}
